import ch31CaseStatusDetails from './ch31-case-status-details';
import ch31PdfLetterDownload from './ch31-pdf-letter-download';
import ch31CaseMilestones from './ch31-case-milestones';

export default {
  ch31CaseStatusDetails,
  ch31PdfLetterDownload,
  ch31CaseMilestones,
};
